<script lang="ts">
  import { slide } from "svelte/transition";
  import ChevronIcon from "@/components/icons/ChevronIcon.svelte";
  import { clickoutside } from "@svelte-put/clickoutside";
  import { cn } from "@/helpers/tw-utils";
  import RecenterIcon from "@/images/navbar-icons/recenter.svg";
  import SwapVertIcon from "@/images/navbar-icons/swap_vert.svg";
  import { Image } from "./image";

  type Link = {
    href: string;
    label: string;
    image?: string;
  };
  interface Props {
    text: string;
    links: Link[];
    showSecondNavbar: boolean;
  }

  let { text, links, showSecondNavbar }: Props = $props();

  let toggled = $state(false);

  const toggle = () => (toggled = !toggled);
</script>

<div
  class="relative inline-block select-none text-left"
  role="button"
  tabindex="0"
  use:clickoutside
  onclickoutside={() => (toggled = false)}>
  <button
    type="button"
    onclick={toggle}
    class={cn(
      "inline-flex w-full cursor-pointer items-center gap-1.5 rounded-[40px] border border-dark-gray bg-light-black px-3 py-[10px] !text-sm font-medium tracking-widest !text-theme-white transition-all duration-300",
      {
        "border border-dark-gray bg-light-black !text-theme-white ": toggled
      }
    )}
    aria-expanded="true"
    aria-haspopup="true">
    {#if !showSecondNavbar}
      <Image src={RecenterIcon} alt="Recenter Icon" class="h-5 w-5" />
    {:else}
      <Image src={SwapVertIcon} alt="Switch Game Icon" class="h-5 w-5" />
    {/if}
    {text}
    <span class="pointer-events-none">
      {#if toggled}
        <ChevronIcon direction="up" />
      {:else}
        <ChevronIcon direction="down" />
      {/if}
    </span>
  </button>

  {#if toggled}
    <div
      class=" right-0 z-10 w-full origin-top-right lg:absolute lg:w-56"
      transition:slide={{ duration: 200 }}
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabindex="-1">
      <div
        role="none"
        class="shadow-[0px_4px_12px_0px_rgba(0,0,0,0.25)]; my-5 rounded-[8px] border border-dark-gray bg-light-black p-2">
        {#each links as link, i (i)}
          <a
            href={link.href}
            class="text-md group flex items-center rounded-[4px] px-4 py-[10px] text-theme-white hover:bg-blue-gray"
            role="menuitem"
            tabindex="-1"
            >{#if link.image}<img
                alt={link.label}
                src={link.image}
                class="mr-3 h-7 w-7" />{/if}{link.label}</a>
        {/each}
      </div>
    </div>
  {/if}
</div>
